export default __webpack_public_path__ + "static/media/lesnik_winter_b_09.506a0bb7.svg";